import { FormatType } from "../../Alert/Filter/FilterType";
import { PropertyLocationFormField } from "../../PropertyLocation/PropertyLocationFormField";
import {
  ConfigurationFormType,
  ConfigurationPageTab,
  ConfigurationPageTables,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";

const SURQUAL_PROPERTY_PAGE_PROPERTY_GROUP_2_TAB: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  label: "PROPERTY_GROUP_2",
  path: "property-groups-2",
  model: {
    entityName: "short_name",
    label: "PROPERTY_GROUP_2",
    path: "/api/property-groups-2",
    name: "hebergement Groupe2",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/property-groups-2/export" },
    import: { path: "/api/property-groups-2/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "separator",
        label: "",
        type: ConfigurationFormType.Separator,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
    ],
    deletable: true,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
    ],
  },
};

const SURQUAL_PROPERTY_PAGE_PROPERTY_GROUP_1_TAB: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  label: "PROPERTY_GROUP_1",
  path: "property-groups-1",
  model: {
    entityName: "short_name",
    label: "PROPERTY_GROUP_1",
    path: "/api/property-groups-1",
    name: "hebergement Groupe1",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText separationColumnRight",
        headerClassName: "separationColumnRight",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
      {
        key: "hebergement_groupe2.short_name",
        order: 4,
        label: "GROUP_2",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/property-groups-1/export" },
    import: { path: "/api/property-groups-1/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/property-groups-2/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "hebergement_groupe2",
        label: "GROUP_2",
        labelKey: "short_name",
        column: "hebergement_groupe2.short_name",
        subCreationForm: SURQUAL_PROPERTY_PAGE_PROPERTY_GROUP_2_TAB,
      },
      {
        key: "separatorQualification",
        label: "QUALIFICATION",
        type: ConfigurationFormType.Separator,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "hebergement_groupe2",
        flex: "50%",
      },
    ],
    deletable: true,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "hebergement_groupe2",
        flex: "50%",
      },
    ],
  },
};

const SURQUAL_PROPERTY_PAGE_PROPERTY_GEO_ZONE_2_TAB: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  label: "PROPERTY_ZONE_GEO_2",
  path: "property-geo-zones-2",
  model: {
    entityName: "short_name",
    label: "PROPERTY_ZONE_GEO_2",
    path: "/api/property-geo-zones-2",
    name: "hebergement Zone2",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/property-geo-zones-2/export" },
    import: { path: "/api/property-geo-zones-2/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "separator",
        label: "",
        type: ConfigurationFormType.Separator,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
    ],
    deletable: true,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
    ],
  },
};

const SURQUAL_PROPERTY_PAGE_PROPERTY_GEO_ZONE_1_TAB: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  label: "PROPERTY_ZONE_GEO_1",
  path: "property-geo-zones-1",
  model: {
    entityName: "short_name",
    label: "PROPERTY_ZONE_GEO_1",
    path: "/api/property-geo-zones-1",
    name: "hebergement Zone1",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText separationColumnRight",
        headerClassName: "separationColumnRight",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
      {
        key: "hebergement_geo_zone2.short_name",
        order: 4,
        label: "GEO_AREA_2",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/property-geo-zones-1/export" },
    import: { path: "/api/property-geo-zones-1/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/property-geo-zones-2/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "hebergement_geo_zone2",
        labelKey: "short_name",
        label: "GEO_AREA_2",
        column: "hebergement_geo_zone2.short_name",
        subCreationForm: SURQUAL_PROPERTY_PAGE_PROPERTY_GEO_ZONE_2_TAB,
      },
      {
        key: "separatorQualification",
        label: "QUALIFICATION",
        type: ConfigurationFormType.Separator,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "hebergement_geo_zone2",
        flex: "50%",
      },
    ],
    deletable: true,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "hebergement_geo_zone2",
        flex: "50%",
      },
    ],
  },
};

const SURQUAL_PROPERTY_PAGE_PROPERTY_TAB: ConfigurationPageTables = {
  description: "CONF_DESC_SELFMAPPING_PROPERTY",
  type: ConfigurationPageType.TABLE,
  label: "PROPERTY",
  path: "",
  model: {
    entityName: "hebergement_nom_court",
    label: "PROPERTY",
    // Must not finish with a `/`
    path: "/api/properties",
    bulkPath: "/api/properties/bulk-updates",
    name: "surqual_property",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "hebergement_nom_court",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText separationColumnRight",
        headerClassName: "separationColumnRight",
        key: "hebergement_nom_long",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
      {
        key: "nb_uh_r12",
        className: "progressOcc",
        order: 4,
        label: "OCC_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS,
        visible: true,
      },
      {
        key: "turnover_r12",
        className: "progressCA",
        order: 5,
        label: "CA_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "pm_r12",
        className: "progressPM",
        order: 6,
        label: "PM_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        align: "right",
        key: "nb_etoiles",
        order: 7,
        label: "NB_STARS",
        visible: true,
        type: FormatType.NUMBER,
      },
      {
        key: "statut_hebergement",
        order: 8,
        label: "STATUS",
        visible: true,
      },
      {
        key: "rm_surqual",
        order: 9,
        label: "RM_SEGMENT",
        visible: true,
      },
      {
        key: "analyst.username",
        order: 10,
        label: "ANALYST",
        visible: true,
      },
      {
        key: "hebergement_groupe1.short_name",
        order: 11,
        label: "GROUP_1",
        visible: true,
      },
      {
        key: "hebergement_geo_zone1.short_name",
        order: 12,
        label: "GEO_AREA_1",
        visible: true,
      },
      {
        key: "vacaf",
        order: 13,
        label: "VACAF",
        visible: true,
        type: FormatType.BOOLEAN,
      },
      {
        key: "vat_rate_pct",
        order: 14,
        label: "VAT_RATE",
        visible: true,
        type: FormatType.NUMBER,
      },
      {
        key: "currency.code",
        order: 15,
        label: "CONFIG.SURQUAL_PROPERTY.CURRENCY",
        visible: true,
        type: FormatType.TEXT,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/properties/?is_unmapped=1",
      },
      {
        type: ConfigurationTableFilterType.Unlocated,
        api: "/api/properties/unlocated-count/",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/properties/export" },
    import: { path: "/api/properties/presign-url" },
  },
  options: {
    formSize: "md",
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "hebergement_nom_court",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "hebergement_nom_long",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "nb_etoiles",
        label: "NB_STARS",
        api: "/api/property-nb-stars/",
        column: "nb_etoiles",
        type: ConfigurationFormType.SelectStars,
      },
      {
        key: "statut_hebergement",
        label: "STATUS",
        api: "/api/property-status/",
        column: "statut_hebergement",
        type: ConfigurationFormType.Input,
      },
      {
        key: "rm_surqual",
        label: "RM_SEGMENT",
        api: "/api/property-rm-segment/",
        column: "rm_surqual",
        type: ConfigurationFormType.Input,
      },
      {
        label: "ANALYST",
        type: ConfigurationFormType.Select,
        api: "/api/analysts/",
        key: "analyst",
        apiParams: {
          page_size: 100,
          ordering: "username",
        },
        column: "analyst.username",
        labelKey: "username",
      },
      {
        key: "hebergement_groupe1",
        label: "GROUP_1",
        type: ConfigurationFormType.Select,
        api: "/api/property-groups-1/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        column: "hebergement_groupe1.short_name",
        labelKey: "short_name",
        subCreationForm: SURQUAL_PROPERTY_PAGE_PROPERTY_GROUP_1_TAB,
      },
      {
        key: "hebergement_geo_zone1",
        label: "GEO_AREA_1",
        type: ConfigurationFormType.Select,
        api: "/api/property-geo-zones-1/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        column: "hebergement_geo_zone1.short_name",
        labelKey: "short_name",
        subCreationForm: SURQUAL_PROPERTY_PAGE_PROPERTY_GEO_ZONE_1_TAB,
      },
      {
        key: "vacaf",
        label: "VACAF",
        type: ConfigurationFormType.Check,
      },
      {
        key: "vat_rate_pct",
        label: "VAT_RATE",
        type: ConfigurationFormType.Input,
        tooltip: "0 - 100",
      },
      {
        key: "currency",
        label: "CONFIG.SURQUAL_PROPERTY.CURRENCY",
        type: ConfigurationFormType.Select,
        api: "/api/currencies/",
        labelKey: "code",
      },
      {
        key: "separatorQualification",
        label: "QUALIFICATION",
        type: ConfigurationFormType.Separator,
      },
      {
        key: "separatorLocation",
        label: "LOCATION",
        type: ConfigurationFormType.Separator,
      },
      {
        key: "propertyLocation",
        label: "LOCATION",
        type: ConfigurationFormType.Warning,
        component: PropertyLocationFormField,
      },
      {
        key: "radius_of_interest",
        label: "RADIUS_OF_INTEREST",
        type: ConfigurationFormType.StaticSelect,
      },
    ],
    copyable: false,
    displayFormError: true,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "hebergement_nom_court",
        flex: "50%",
        required: true,
      },
      {
        key: "hebergement_nom_long",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "nb_etoiles",
        flex: "100%",
      },
      {
        key: "hebergement_geo_zone1",
        flex: "50%",
      },
      {
        key: "hebergement_groupe1",
        flex: "50%",
      },
      {
        key: "statut_hebergement",
        flex: "33%",
      },
      {
        key: "rm_surqual",
        flex: "33%",
      },
      {
        key: "analyst",
        flex: "50%",
      },
      {
        key: "separator",
        flex: "100%",
      },
      {
        key: "vacaf",
        flex: "100%",
      },
      {
        key: "vat_rate_pct",
        flex: "100%",
      },
      {
        key: "currency",
        flex: "100%",
      },
    ],
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "hebergement_nom_court",
        flex: "50%",
        required: true,
      },
      {
        key: "hebergement_nom_long",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "nb_etoiles",
        flex: "100%",
      },
      {
        key: "hebergement_groupe1",
        flex: "50%",
      },
      {
        key: "hebergement_geo_zone1",
        flex: "50%",
      },
      {
        key: "statut_hebergement",
        flex: "50%",
      },
      {
        key: "rm_surqual",
        flex: "50%",
      },
      {
        key: "analyst",
        flex: "100%",
      },
      {
        key: "separator",
        flex: "100%",
      },
      {
        key: "vacaf",
        flex: "100%",
      },
      {
        key: "vat_rate_pct",
        flex: "100%",
      },
      {
        key: "currency",
        flex: "100%",
      },
      {
        key: "separatorLocation",
        flex: "100%",
      },
      {
        key: "propertyLocation",
        flex: "100%",
      },
      {
        key: "radius_of_interest",
        flex: "100%",
      },
    ],
    editSelectedOptions: [
      {
        key: "hebergement_groupe1",
        flex: "50%",
      },
      {
        key: "hebergement_geo_zone1",
        flex: "50%",
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "nb_etoiles",
        flex: "100%",
      },
      {
        key: "statut_hebergement",
        flex: "50%",
      },
      {
        key: "rm_surqual",
        flex: "50%",
      },
      {
        key: "analyst",
        flex: "100%",
      },
      {
        key: "vacaf",
        flex: "100%",
      },
      {
        key: "vat_rate_pct",
        flex: "100%",
      },
      {
        key: "currency",
        flex: "100%",
      },
    ],
    deletable: true,
    // Never the generic DELETE /api/properties/<id>/: it cascades 10 relations
    // (pickup models, KPI history, ...) with no backup, then hits the
    // hebergement_uh_cat foreign key and rolls the whole thing back — except on
    // a property with no uh_cat, where it succeeds and destroys those 10
    // relations irreversibly.
    deleteTarget: "property",
  },
};

export const SURQUAL_PROPERTY_PAGE: ConfigurationPageTab = {
  type: ConfigurationPageType.TABS,
  count: 0,
  description: "CONF_PAGE_DESC_DEFAULT",
  label: "PROPERTY",
  pageLabel: "PROPERTY_TITLE_SURQUAL",
  menuLabel: "PROPERTY",
  name: "property",
  path: "hebergement",
  tabs: [
    SURQUAL_PROPERTY_PAGE_PROPERTY_TAB,
    SURQUAL_PROPERTY_PAGE_PROPERTY_GROUP_1_TAB,
    SURQUAL_PROPERTY_PAGE_PROPERTY_GROUP_2_TAB,
    SURQUAL_PROPERTY_PAGE_PROPERTY_GEO_ZONE_1_TAB,
    SURQUAL_PROPERTY_PAGE_PROPERTY_GEO_ZONE_2_TAB,
  ],
};
